import { render, staticRenderFns } from "./MetabaseReport.vue?vue&type=template&id=7e4a1fe2&scoped=true"
import script from "./MetabaseReport.vue?vue&type=script&lang=js"
export * from "./MetabaseReport.vue?vue&type=script&lang=js"
import style0 from "./MetabaseReport.vue?vue&type=style&index=0&id=7e4a1fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4a1fe2",
  null
  
)

export default component.exports